import * as React from 'react';

export interface IDropdownMenuOptionProps {
  title: string;
  onClick?(): void;
  extraWide: boolean
}

export default ({ title, onClick, extraWide }: IDropdownMenuOptionProps) => (
  
  <div className="dropdownmenu-option" style={extraWide ? {width: '358px'} : {}} onClick={() => onClick && onClick()}>
    {title}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/DropdownMenuOption.tsx